package one.healthium.promo_banner.di

import one.healthium.promo_banner.ui.PromoBannerViewModel
import org.koin.core.module.dsl.viewModelOf
import org.koin.dsl.module

val promoBannerModule = module {
    viewModelOf(::PromoBannerViewModel)
}
